// Spec 32 - DTO + labels voor employee-contractdocumenten.
// Mirrort Prisma-enum `DocumentType` uit packages/db/prisma/schema.prisma.

// batch-42 onboarding (FO-370) — LOONHEFFINGSKORTING + RIJBEWIJS erbij zodat de
// loonheffingskorting-verklaring en de rijbewijs-scan herkenbare dossier-
// documenttypen zijn (aanmeldpakket-export vindt ze).
// batch-42 meldingen-fixes (FO-371 fix 2) — BEKEURING erbij (scan/brief van een
// bekeuring). Mirrort de Prisma-enum `DocumentType`; elke waarde heeft een eigen
// losse ADD VALUE-migratie.
export const DOCUMENT_TYPES = [
  'LEGITIMATIE',
  'CONTRACT',
  'LOONHEFFINGSKORTING',
  'RIJBEWIJS',
  'BEKEURING',
  'OVERIG',
] as const
export type DocumentTypeValue = (typeof DOCUMENT_TYPES)[number]

export const DOCUMENT_TYPE_LABELS: Record<DocumentTypeValue, string> = {
  LEGITIMATIE:         'Legitimatie',
  CONTRACT:            'Contract',
  LOONHEFFINGSKORTING: 'Loonheffingskorting',
  RIJBEWIJS:           'Rijbewijs',
  BEKEURING:           'Bekeuring',
  OVERIG:              'Overig',
}

export interface EmployeeDocumentDTO {
  id: string
  employeeId: string
  type: DocumentTypeValue
  fileName: string
  mimeType: string | null
  fileSize: number | null
  uploadedByName: string | null
  uploadedAt: string // ISO-datetime
  createdAt: string
}
